import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConstants } from '@core/app-constants';
import { ChangePasswordPayload } from '@shared/component/my-account/model/change-password.model';
import { UpdateProfilePayload, UserProfile } from '@shared/model/user-profile.model';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class UserProfileService {
	constructor(private readonly http: HttpClient) {}

	public getProfile(): Observable<UserProfile> {
		return this.http.get<UserProfile>(`${AppConstants.apiUrl}/profile`);
	}

	public changePassword(data: ChangePasswordPayload): Observable<ChangePasswordPayload> {
		return this.http.post<ChangePasswordPayload>(`${AppConstants.apiUrl}/change-password`, data);
	}

	public updateProfile(data: UpdateProfilePayload): Observable<UserProfile> {
		return this.http.patch<UserProfile>(`${AppConstants.apiUrl}/update-profile`, data);
	}
}
